import React, { useCallback } from 'react';
import { useField } from 'formik';
import { ITextInputProps, TextInput } from '../TextInput';

//FYI: this simplifies integration with Formik. See README

interface ITextField extends Partial<ITextInputProps> {
  name: string;
}

export const TextField: React.FC<ITextField> = ({ name, onChange: onChangeProp, ...rest }) => {
  const [field, meta, { setValue, setTouched }] = useField({ name });
  const onChange = useCallback(
    async (value: any) => {
      await setTouched(true);
      await setValue(value);
      if (onChangeProp) {
        onChangeProp(value);
      }
    },
    [onChangeProp, setValue, setTouched]
  );
  return (
    <TextInput
      {...rest}
      {...field}
      onChange={onChange}
      errorText={rest.errorText || meta.error}
      data-test-id={rest['data-test-id'] || name}
    />
  );
};
